// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"loader_loader-container__YsVbt","lds-roller":"loader_lds-roller__PynPo"};